import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84fac4b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = { class: "logo-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "mb-m"
}
const _hoisted_6 = { class: "list" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_use_svg = _resolveComponent("use-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_header_link = _resolveComponent("header-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "navigation-toggler",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleNav && _ctx.toggleNav(...args)))
        }, [
          _createVNode(_component_use_svg, { svg: "menu" })
        ]),
        _createVNode(_component_router_link, {
          class: "logo-link",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.logoSrc,
              style: _normalizeStyle(_ctx.logoStyle),
              alt: "logo",
              class: "logo"
            }, null, 12, _hoisted_4)
          ]),
          _: 1
        })
      ]),
      _createVNode(_Transition, { name: "slide-down" }, {
        default: _withCtx(() => [
          (_ctx.showMenu)
            ? (_openBlock(), _createElementBlock("nav", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_header_link, {
                      onClick: _ctx.hideMenu,
                      svg: "newspaper",
                      to: "/"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate('overview.title')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_header_link, {
                      onClick: _ctx.hideMenu,
                      svg: "clock",
                      to: "/history"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate('history.title')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_header_link, {
                      onClick: _ctx.hideMenu,
                      svg: "folder",
                      to: "/details"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate('details.title')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  (_ctx.hasHelpContent)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                        _createVNode(_component_header_link, {
                          onClick: _ctx.hideMenu,
                          svg: "question",
                          to: "/help"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate('help.title')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 512), [
      [_directive_click_outside, _ctx.hideMenu]
    ])
  ]))
}